import { nestedRemoveNaN, sanitizeInsuranceCoverage, UpdateAssessmentAnswersArgs } from '@hb/shared'
import { updateAssessmentAnswersFunction } from '../../backend/functions/assessments'
import { useMissingForms } from '../../contexts/MissingFormsContext'

export const updateAssessmentAnswers = async ({
  id,
  data,
  appName,
}: UpdateAssessmentAnswersArgs) => {
  const submitted = nestedRemoveNaN(data)
  if (submitted?.delivery?.midwife) delete submitted.delivery.midwife
  if (submitted?.insuranceInfo?.primaryCoverage) {
    submitted.insuranceInfo.primaryCoverage = sanitizeInsuranceCoverage(
      submitted?.insuranceInfo?.primaryCoverage,
    )
  }
  if (submitted?.insuranceInfo?.secondaryCoverage) {
    submitted.insuranceInfo.secondaryCoverage = sanitizeInsuranceCoverage(
      submitted?.insuranceInfo?.secondaryCoverage,
    )
  }
  if (submitted?.insuranceInfo?.medicaidCoverage) {
    submitted.insuranceInfo.medicaidCoverage = sanitizeInsuranceCoverage(
      submitted?.insuranceInfo?.medicaidCoverage,
    )
  }
  return updateAssessmentAnswersFunction({ id, data: submitted, appName })
}

export const useUpdateAssessmentAnswers = () => {
  const { setMissingForms } = useMissingForms()

  return async (args: UpdateAssessmentAnswersArgs) => {
    const result = await updateAssessmentAnswers(args)
    const { missingForms = [] } = result.data
    setMissingForms(missingForms)
    return result
  }
}
